import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as createWizardReducer from "containers/CreateWizard/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as runReducer from "containers/Run/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";

import DatasetViewContainer from "containers/View/Dataset";

import SelectData from "components/UnifiedProject/SelectData/SelectData";

class SelectDataContainer extends React.PureComponent {
  handleUpdateSelection(selection) {
    const { updateSelection, generateNameAndUpdate, blueprintId, id } = this.props;

    return updateSelection(selection).then(() => {
      if (id === "new" && (blueprintId === "template" || blueprintId === "academic"))
        return generateNameAndUpdate(selection.value, blueprintId === "academic" ? undefined : "Optimized");
    });
  }

  render() {
    const { blueprintId, id, index, blueprint, transformed, isNextDatasetSelect } = this.props;

    return (
      <SelectData
        {...this.props}
        datasetView={
          <DatasetViewContainer
            isChatStyle={this.props.isChatStyle}
            blueprintId={blueprintId}
            onClick={isNextDatasetSelect ? undefined : (s) => this.handleUpdateSelection({ value: s })}
          />
        }
        updateSelection={(selection) => this.handleUpdateSelection({ value: selection })}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id;
  return {
    removeStep: () => dispatch(blueprintReducer.removeStepById(ownProps.runId, ownProps.blueprintId, ownProps.type)),
    updateOption: (option, value) =>
      dispatch(runReducer.updateWizardOption(ownProps.runId, ownProps.type, option, value)),

    incrementStep: (index) => dispatch(wizardReducer.incrementStep(ownProps.runId, ownProps.blueprintId, index)),

    increasePriority: (index) =>
      dispatch(blueprintReducer.increasePriority(ownProps.runId, ownProps.blueprintId, index)),
    decreasePriority: (index) =>
      dispatch(blueprintReducer.decreasePriority(ownProps.runId, ownProps.blueprintId, index)),

    checkIsEnabledTab: (key, value) =>
      dispatch((dispatch, getState) => wizardReducer.checkIsEnabledTab(getState(), key, value)),

    updatePanelMode: (panelMode) =>
      dispatch(runReducer.updatePanelMode(ownProps.originalId, ownProps.blueprintId, panelMode)),
    updateIsEditing: (isEditing) => dispatch(blueprintReducer.updateIsEditing(ownProps.blueprintId, isEditing)),
    updateSelection: (selection) =>
      dispatch(
        setupReducer.updateDatasetId(
          ownProps.runId,
          selection.value,
          true,
          ownProps.index,
          ownProps.blueprintId,
          true,
          ownProps.hasProject,
          undefined,
          ownProps.nextId
        )
      ),
    generateNameAndUpdate: (datasetId, message) =>
      dispatch(setupReducer.generateNameAndUpdate(ownProps.runId, datasetId, message)),
    updateSuccess: (success) => {
      dispatch(setupReducer.updateSuccess(ownProps.runId, success));
      dispatch(setupReducer.checkCounts(ownProps.runId));
    },
    updateSplitColumn: (column) => dispatch(setupReducer.updateSplitColumn(ownProps.runId, column)),
    updateStep: (step) => dispatch(createWizardReducer.updateStep(step)),
    updateIgnored: (column, isIgnored) => dispatch(setupReducer.updateIgnored(ownProps.runId, column, isIgnored)),
    setCustomMapping: (customFieldId, datasetColumn) =>
      dispatch(setupReducer.setCustomMapping(ownProps.runId, ownProps.blueprintId, customFieldId, datasetColumn)),
    createSplits: (splitCol) => dispatch(projectReducer.createSplits(ownProps.projectId, splitCol, null, false, true)),

    updateIsForecast: (val) => dispatch(setupReducer.updateIsForecastH(ownProps.runId, val)),
    updateForecastMode: (val) => dispatch(setupReducer.updateForecastModeH(ownProps.runId, val)),
    updateForecastTimeCol: (val) => dispatch(setupReducer.updateForecastTimeCol(ownProps.runId, val)),
    createAndUpdateProject: () => dispatch(nextReducer.createAndUpdateProject(ownProps.nextId, ownProps.runId)),

    updateEnableFairnessMetrics: (val) => dispatch(setupReducer.updateEnableFairnessMetrics(ownProps.runId, val)),

    updateTargetValue: (datasetId, targetValue) => dispatch(homeReducer.updateTargetValue(datasetId, targetValue))
  };
};

const mapStateToProps = (state, ownProps) => {
  const selectedDataset = ownProps.selectedDataset
    ? ownProps.selectedDataset
    : setupReducer.getDatasetFromSetup(state, ownProps.runId);
  const outcomeType = selectedDataset ? setupReducer.getOutcomeType(state, ownProps.runId) : null;
  const aiReadyMetrics = setupReducer.getAiReadyMetrics(state, ownProps.runId) || {};
  const correlations = setupReducer.getCorrelationMetricsFromDataset(state, ownProps.runId) || {};

  const isEditBlueprint =
    (ownProps.id === "new" && ownProps.blueprintId === "new") ||
    blueprintReducer.getIsEditing(state, ownProps.blueprintId);

  const wStep = wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET;

  const type = ownProps.type ? ownProps.type : wizardReducer.STEP_TYPE.CHOOSE_DATASET.id;

  const steps = wizardReducer.getSteps(state, ownProps.id, ownProps.blueprintId);

  const stepIndex = wizardReducer.getStepIndex(state, ownProps.id, ownProps.blueprintId);

  let isRunning = false;
  let hasModels = false;
  if (ownProps.id && ownProps.id !== "new") {
    const runStatus = ownProps.id && ownProps.id !== "new" ? runReducer.getStatus(state, ownProps.id) : null;
    isRunning = runStatus !== "DONE" && runStatus !== "ERROR";

    const models = runReducer.getTransformedSortedModels(state, ownProps.id);
    const selModel = runReducer.getSelModel(state, ownProps.id);
    hasModels =
      models !== undefined && selModel !== undefined && models.filter((m) => m.id !== "Current State").length !== 0;
  }

  const aibleMode = wizardReducer.getAibleMode(state, ownProps.id);

  const blueprint = ownProps.blueprint;

  const retSelectedDataset = isEditBlueprint
    ? blueprint && blueprint.wizard && blueprint.wizard.dataset
      ? blueprint.wizard.dataset
      : undefined
    : selectedDataset;

  return {
    project: projectReducer.getProject(state, ownProps.projectId),

    id: ownProps.runId,
    selectedDataset: selectedDataset,
    outcomeType: outcomeType,

    selectedSuccess: setupReducer.getSuccess(state, ownProps.runId),
    successOptions: setupReducer.getSuccessOptions(state, ownProps.runId),
    successOptionsWarning: setupReducer.getSuccessOptionsWarning(state, ownProps.runId),

    blueprint: setupReducer.getBlueprintFromSetup(state, ownProps.runId),

    splitOptions: setupReducer.getSplitOptions(state, ownProps.runId),
    splitColumn: setupReducer.getSplitColumn(state, ownProps.runId),

    step: createWizardReducer.getStep(state),
    ignored: setupReducer.getIgnored(state, ownProps.runId),

    problematicPredictors: correlations.problematicPredictors,
    predictors: correlations.predictors,

    transformed: transformReducer.getCalculatedFields(state, ownProps.runId),
    aiReadyFields: aiReadyMetrics.aiReady,
    notAiReadyFields: aiReadyMetrics.notAiReady,
    isAiReady: aiReadyMetrics.isAiReady,
    aiReadyWarning: aiReadyMetrics.warning,
    isMultiCategoryOutcome: aiReadyMetrics.isMultiCategoryOutcome,
    hasIgnoredAiReady: aiReadyMetrics.hasIgnoredAiReady,

    customMappings: setupReducer.getCustomMappingsArr(state, ownProps.runId),
    customMappingOptions: setupReducer.getCustomMappingOptions(state, ownProps.runId),
    validCustomMappings: setupReducer.getIsValidCustomMappings(state, ownProps.runId),

    isForecastReady: homeReducer.getIsForecastReady(state, selectedDataset && selectedDataset.id),
    isForecast: setupReducer.getIsForecast(state, ownProps.runId),
    forecastMode: setupReducer.getForecastModeH(state, ownProps.runId),
    forecastOptions: homeReducer.getForecastOptions(state, selectedDataset && selectedDataset.id),
    forecastTimeCol: setupReducer.getForecastTimeCol(state, ownProps.runId),

    enableFairnessMetrics: setupReducer.getEnableFairnessMetrics(state, ownProps.runId),

    outcomeSuccess: galleryReducer.getOutcomeSuccess(state, selectedDataset && selectedDataset.id),
    hasUpdatedOutcomeSuccess: galleryReducer.hasUpdatedOutcomeSuccess(state, selectedDataset && selectedDataset.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SelectDataContainer);
